import { confirmAlert } from "react-confirm-alert";
import { Trans } from "react-i18next";

let defaultAlertMessages = {
  TitleError: <Trans>warning</Trans>,
  TitleWarning: <Trans>warning</Trans>,
  TitleSuccess: <Trans>success</Trans>,
  MessageDetailError: <Trans>please_try_again</Trans>,
  MessageDetailWarning: <Trans>sure_continue</Trans>,
  MessageDetailSuccess: <Trans>successfully_completed</Trans>,
  Ok: <Trans>ok</Trans>,
  Yes: <Trans>yes</Trans>,
  No: <Trans>no</Trans>,
};

export const serviceMessageError = (message) => {
  defaultAlertMessages.MessageDetailError = message;
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmErrorMessage(onClose, defaultAlertMessages);
    },
  });
};

const getConfirmErrorMessage = (onClose, options) => {
  return (
    <div className="custom-ui">
      <h1 style={{ color: "red" }}>{options.TitleError}</h1>
      <p>{options.MessageDetailError}</p>
      <button onClick={onClose}>{options.Ok}</button>
    </div>
  );
};
